export const theme = {
  danger: "#dc3545",
  inputBorderColor: "#ced4da",
};
